const setId = <T extends {}>(value: T, index: number): T & { id: number } => ({
    id: index,
    ...value,
});

export default setId;
